/* THIS FILE IS AUTO-GENERATED! DO NOT MODIFY!! */
/* eslint-disable */
// @ts-nocheck

import type * as Types from '@/graphql';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { WorkspaceOrgSharedEndpointsFragmentDoc } from '../../../WorkspaceTeams/ModelAPIs/__generated__/fragments.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WorkspaceOrgSharedEndpointsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type WorkspaceOrgSharedEndpointsQuery = { __typename?: 'QueryPrediction', organizationSharedEndpoints: Array<{ __typename?: 'OrganizationSharedEndpointType', id: string, created: any, sharedEndpoint: { __typename?: 'SharedEndpointType', id: string, name: string, modelFamily: Types.SharedEndpointModelFamily | null | undefined } } | null | undefined> | null | undefined };


export const WorkspaceOrgSharedEndpointsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkspaceOrgSharedEndpoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"organizationSharedEndpoints"},"name":{"kind":"Name","value":"organization_shared_endpoints"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"WorkspaceOrgSharedEndpointsFragment"}}]}}]}},...WorkspaceOrgSharedEndpointsFragmentDoc.definitions]} as unknown as DocumentNode<WorkspaceOrgSharedEndpointsQuery, WorkspaceOrgSharedEndpointsQueryVariables>;
export const namedOperations = {
  Query: {
    WorkspaceOrgSharedEndpoints: 'WorkspaceOrgSharedEndpoints'
  }
}

/**
 * __useWorkspaceOrgSharedEndpointsQuery__
 *
 * To run a query within a React component, call `useWorkspaceOrgSharedEndpointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceOrgSharedEndpointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceOrgSharedEndpointsQuery({
 *   variables: {
 *   },
 * });
 */
export function useWorkspaceOrgSharedEndpointsQuery(baseOptions?: Apollo.QueryHookOptions<WorkspaceOrgSharedEndpointsQuery, WorkspaceOrgSharedEndpointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WorkspaceOrgSharedEndpointsQuery, WorkspaceOrgSharedEndpointsQueryVariables>(WorkspaceOrgSharedEndpointsDocument, options);
      }
export function useWorkspaceOrgSharedEndpointsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WorkspaceOrgSharedEndpointsQuery, WorkspaceOrgSharedEndpointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WorkspaceOrgSharedEndpointsQuery, WorkspaceOrgSharedEndpointsQueryVariables>(WorkspaceOrgSharedEndpointsDocument, options);
        }
export type WorkspaceOrgSharedEndpointsQueryHookResult = ReturnType<typeof useWorkspaceOrgSharedEndpointsQuery>;
export type WorkspaceOrgSharedEndpointsLazyQueryHookResult = ReturnType<typeof useWorkspaceOrgSharedEndpointsLazyQuery>;
export type WorkspaceOrgSharedEndpointsQueryResult = Apollo.QueryResult<WorkspaceOrgSharedEndpointsQuery, WorkspaceOrgSharedEndpointsQueryVariables>;
export function refetchWorkspaceOrgSharedEndpointsQuery(variables?: WorkspaceOrgSharedEndpointsQueryVariables) {
      return { query: WorkspaceOrgSharedEndpointsDocument, variables: variables }
    }